export const CANDIDATE_ROUTES = {
  BASE: '/candidate',
  ABOUT_ME: '/candidate/about-me',
  TALENT_PROFILE: '/candidate/talent-profile',
  SKILLS: '/candidate/skills',
  CAREER_SCHOOL: '/candidate/career-school',
  PERSONAL_BRANDING: '/candidate/personal-branding',
  PROFILE_TAB_ABOUT_ME: 'about-me',
  PROFILE_TAB_TALENT_PROFILE: 'talent-profile',
  PROFILE_TAB_SKILLS: 'skills',
  PROFILE_TAB_CAREER_SCHOOL: 'career-school',
  PROFILE_TAB_PERSONAL_BRANDING: 'personal-branding',
  FIND_JOBS: '/candidate/find-jobs',
  APPLICATIONS: '/candidate/applications',
  profile: (id: string | number) => `/candidates/${id}`,
  profileTab: (id: string | number, tab: string) => `/candidates/${id}/${tab}`,
  preview: (id: string | number) => `/preview/${id}`,
  previewTab: (id: string | number, tab: string) => `/preview/${id}/${tab}`
} as const;

export const CANDIDATE_DEFAULT_ROUTE = CANDIDATE_ROUTES.ABOUT_ME;
